/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const SpeedFastIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Speed Fast',
} = {}): string | TemplateResult => {
  return html`<svg
    data-name="ICONS"
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M17.20316,5.29927c-.24425-.24425-.62229-.27212-.87299-.06002-1.38972,1.17572-6.84646,5.98684-7.16766,6.30804-.46196.47765-.42965,1.25957.07216,1.74647.49058.476,1.25108.49536,1.71804.04374.32046-.3212,5.13355-5.77564,6.31026-7.16497.21232-.25068.18454-.62891-.05981-.87325h0Z"
      fill="currentColor"
    />
    <path
      d="M16.48779,15.25c-.12793,0-.25732-.03223-.37549-.10156-.3584-.20703-.48047-.66602-.27295-1.02441.5957-1.02832.91064-2.19434.91064-3.37402,0-.36035-.03467-.7373-.10645-1.1543-.06982-.4082.2041-.7959.6123-.86621.4126-.06543.79639.2041.86621.6123.08594.50195.12793.96191.12793,1.4082,0,1.44336-.38477,2.87012-1.11279,4.12598-.13916.24023-.39111.37402-.64941.37402Z"
      fill="currentColor"
    />
    <path
      d="M3.51221,15.25c-.25879,0-.51025-.13379-.64941-.37402-.72803-1.25586-1.11279-2.68262-1.11279-4.12598C1.75,6.20117,5.45117,2.5,10,2.5c1.5127,0,2.99902.4209,4.29932,1.21777.35303.2168.46387.67871.24756,1.03125-.21631.35352-.67773.46387-1.03174.24805-1.06396-.65234-2.2793-.99707-3.51514-.99707-3.72217,0-6.75,3.02832-6.75,6.75,0,1.17969.31494,2.3457.91064,3.37402.20752.3584.08545.81738-.27295,1.02441-.11816.06934-.24756.10156-.37549.10156Z"
      fill="currentColor"
    />
  </svg>`;
};
